import { createFileRoute } from '@tanstack/react-router';

import { ConnectOfferDownloadAppsPage } from 'src/apps/checkout/app/pages/ConnectOffer.DownloadApps';

export const Route = createFileRoute(
  '/_auth/_only-header/store/connect-offer/download-apps'
)({
  component: () => <ConnectOfferDownloadAppsPage />,
});
